module.exports = __webpack_public_path__ + "static/fipcballoonanimal-cdbafc77be251807eef98dbc162ee730.jpeg";